import { post, postExFile, postFile } from "@utils/httpUtil";
//////////////////////////////////////////
// 医问咖答活动-问答管理列表
export function findDoctorQuestionExpertAnswerQAPage(data, config) {
  return post(`/c/pc/sp/popularActivity/findDoctorQuestionExpertAnswerQAPage`, data, config);
}
export function popularActivitySaveActivity(data, config) {
  return post(`/c/pc/sp/activity/saveActivity`, data, config);
}
export function bindBudgetActivityId(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/bindBudgetActivityId`, data, config);
}
//活动任务详情;
export function popularActivityActivityTaskDetail(data, config) {
  return post(`/c/pc/sp/activity/activityTaskDetail`, data, config);
}
// 约医生导出;
export function activityDoctorExportPromotionActivityUser(data, config) {
  return postExFile(`/c/pc/sp/activityDoctor/exportPromotionActivityUser`, data, config);
}
//更新活动任务基础信息
export function activityUpdateTaskInfo(data, config) {
  return post(`/c/pc/sp/activity/updateTaskInfo`, data, config);
}
//更新活动参与规则
export function activityUpdateTaskRule(data, config) {
  return post(`/c/pc/sp/activity/updateTaskRule`, data, config);
}
//更新活动参与规则
export function updateActivityBasicInfo(data, config) {
  return post(`/c/pc/sp/activity/updateActivityBasicInfo`, data, config);
}
//更新活动任务规则
export function activityUpdateActivityExt(data, config) {
  return post(`/c/pc/sp/activity/updateActivityExt`, data, config);
}
//更新活动任务规则
export function insertActivityTaskRuleRelation(data, config) {
  return post(`/c/pc/sp/activity/insertActivityTaskRuleRelation`, data, config);
}
//添加单个活动任务
export function activityAddSingleTask(data, config) {
  return post(`/c/pc/sp/activity/addSingleTask`, data, config);
}
export function activityDeleteActivity(data, config) {
  return postExFile(`/c/pc/sp/activity/deleteActivity`, data, config);
}
export function popularActivity_endActivity(data, config) {
  return postExFile(`/c/pc/sp/popularActivity/endActivity`, data, config);
}
// 查询可结束任务
export function activityTaskUserRecordCanEndTaskList(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/canEndTaskList`, data, config);
}
//
export function popularActivityCreateActivity(data, config) {
  return post(`/c/pc/sp/popularActivity/createActivity`, data, config);
}
export function activityTaskUserRecordActivityDataExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonActivityDataExport`, data, config);
}
//导出活动文章
export function activityTaskUserRecordActivityDataSourceFileExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/activityDataSourceFileExport`, data, config);
}
//导出活动问卷zip
export function activityTaskUserRecordQuestionnaireActivityAnswerContentZipExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/questionnaireActivityAnswerContentZipExport`, data, config);
}
//导出健康解读zip
export function activityTaskUserRecordHealthInterpretZipExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/healthInterpretZipExport`, data, config);
}
//导出活动问卷zip/reviews
export function activityTaskUserRecordReviewsActivityContentZipExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/reviewsActivityContentZipExport`, data, config);
}
//导出咖答zip
export function expertAnswerActivityContentZipExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/expertAnswerActivityContentZipExport`, data, config);
}
//点评内容管理分页列表
export function popularActivityFindReviewsRecordContentActivityPage(data, config) {
  return post(`/c/pc/sp/popularActivity/findReviewsRecordContentActivityPage`, data, config);
}
// 科普活动 - 修改活动;
export function popularActivityUpdateActivity(data, config) {
  return post(`/c/pc/sp/popularActivity/updateActivity`, data, config);
}
// 科普活动-更新进行中状态的活动
export function popularActivityUpdateStartedActivity(data, config) {
  return post(`/c/pc/sp/popularActivity/updateStartedActivity`, data, config);
}
// 科普活动 - 更新活动落地页信息;
export function popularActivityUpdateLandingPage(data, config) {
  return post(`/c/pc/sp/popularActivity/updateLandingPage`, data, config);
}
// 科普活动 - 预算配置读取;
export function budget_findProjectExtByProjectId(data, config) {
  return post(`${process.env.VUE_APP_BUDGET_LINK}/bizc/c/pc/sp/activity/findProjectExtByProjectId`, data, config);
}
export function popularActivityActivityDetail(data, config) {
  return post(`/c/pc/sp/activity/activityDetail`, data, config);
}
export function popularActivityCheckActivityName(data, config) {
  return post(`/c/pc/sp/popularActivity/checkActivityName`, data, config);
}
export function findCustomerProjectById(data, config) {
  return post(`/c/pc/sp/activity/findCustomerProjectById`, data, config);
}
export function findContributeSubmitTime(data, config) {
  return post(`/c/pc/sp/popularActivity/findContributeSubmitTime`, data, config);
}
export function popularActivityPopularActivityTaskDetail(data, config) {
  return post(`/c/pc/sp/popularActivity/popularActivityTaskDetail`, data, config);
}
export function popularActivity_updateActivityEndTime(data, config) {
  return post(`/c/pc/sp/activity/updateActivityEndTime`, data, config);
}
export function popularActivity_updateActivityApplyTime(data, config) {
  return post(`/c/pc/sp/activity/updateActivityApplyTime`, data, config);
}
export function popularActivity_updateIntroduceAndCover(data, config) {
  return post(`/c/pc/sp/activity/updateIntroduceAndCover`, data, config);
}
export function popularActivity_updateActivityCover(data, config) {
  return post(`/c/pc/sp/activity/updateActivityCover`, data, config);
}
//更新任务时间
export function popularActivity_updateActivityTaskEndTime(data, config) {
  return post(`/c/pc/sp/activity/updateActivityTaskEndTime`, data, config);
}
//删除任务
export function popularActivity_deleteDisseminateMultiTask(data, config) {
  return post(`/c/pc/sp/activity/deleteActivityTask`, data, config);
}
//添加任务
export function popularActivity_startedActivitySaveActivityTask(data, config) {
  return post(`/c/pc/sp/activity/startedActivitySaveActivityTask`, data, config);
}
//编辑任务
export function popularActivity_updateDisseminateMultiTask(data, config) {
  return post(`/c/pc/sp/activity/updateActivityTask`, data, config);
}
//任务检查
export function popularActivity_disseminateMultiTaskCheck(data, config) {
  return post(`/c/pc/sp/activity/disseminateMultiTaskCheck`, data, config);
}
export function popularActivityFindByPage(data, config) {
  return post(`/c/pc/sp/popularActivity/findByPage`, data, config);
}
export function popularActivityArticleSubjectFindByPage(data, config) {
  return post(`/c/pc/sp/popularActivity/articleSubjectFindByPage`, data, config);
}
export function popularActivityActivityTaskUserRecordTaskPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/taskPage`, data, config);
}
export function popularActivityFindByPageExport(data, config) {
  return postExFile(`/c/pc/sp/popularActivity/findByPageExport`, data, config);
}
export function popularActivity_createMiniProgramQRCode(data, config) {
  return post(`/c/pc/sp/popularActivity/createMiniProgramQRCode`, data, config);
}
export function crawlerQuestionnaireAnswerDetail(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/crawlerQuestionnaireAnswerDetail`, data, config);
}
export function exportActivityUserJoined(data, config) {
  return postExFile(`/c/pc/sp/activityDoctor/exportActivityUserJoined`, data, config);
}
export function activityDoctorExportActivityUserApplySubmit(data, config) {
  return postExFile(`/c/pc/sp/activityDoctor/exportActivityUserApplySubmit`, data, config);
}
// 查看已参加医生名单;
export function activityDoctorFindPageActivityUserJoined(data, config) {
  return post(`/c/pc/sp/activityDoctor/findPageActivityUserJoined`, data, config);
}
// 报名列表;
export function activityDoctorCommonApplyAuditPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/commonApplyAuditPage`, data, config);
}
// 报名列表;_待审核
export function activityDoctorCommonApplyWaitApplyAuditPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/commonApplyWaitApplyAuditPage`, data, config);
}
// 报名列表 信息收集;
export function activityDoctorInformationCollectionPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/informationCollectionPage`, data, config);
}
// 报名列表;
export function activityDoctorApplyAudit(data, config) {
  return post(`/c/pc/sp/activityDoctor/applyAudit`, data, config);
}
//科普活动-逻辑删除活动
export function popularActivityDeleteActivity(data, config) {
  return post(`/c/pc/sp/popularActivity/deleteActivity`, data, config);
}
export function popularActivityResetIsPublic(data, config) {
  return post(`/c/pc/sp/popularActivity/resetIsPublic`, data, config);
}
// 科普活动-设置活动文章公开
// export function popularActivityResetArticleVisibleType(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`/c/pc/sp/popularActivity/resetArticleVisibleType`, data, config);
// }
// 科普活动-设置活动文章公开
export function popularActivityUpdateActivityExtContent(data, config) {
  return post(`/c/pc/sp/popularActivity/updateActivityExtContent`, data, config);
}
//校验当前社区是否是升级为v2的社区
export function checkUpgradeCommunityIds(data, config) {
  return post(`/v2/community/checkUpgradeCommunityIds`, data, config);
}
//desc: "获取社区配置",
export function getCommunityConfig(data, config) {
  return post(`/community/config/getCommunityConfig`, data, config);
}
//desc: "保存社区配置",
export function saveCommunityConfig(data, config) {
  return post(`/community/config/saveCommunityConfig`, data, config);
}
//desc: "查看社区配置",
export function findActivityCommonConfigNew(data, config) {
  return post(`/c/pc/sp/activity/findActivityCommonConfig`, data, config);
}
//desc: "查看社区配置2",
export function findContentSubjectListByCommunityTag(data, config) {
  return post(`/c/pc/sp/activity/findContentSubjectListByCommunityTag`, data, config);
}
//desc: "编辑社区配置",
export function activityCommonConfigSaveOrUpdate(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/saveOrUpdate`, data, config);
}
//desc: "编辑社区配置-删除",
export function activityCommonConfigDelete(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/delete`, data, config);
}
//desc: "获取社区配置",
export function findActivityAuditConfig(data, config) {
  return post(`/c/pc/sp/activity/findActivityAuditConfig`, data, config);
}
//desc: "保存社区配置",
export function saveActivityAuditConfig(data, config) {
  return post(`/c/pc/sp/activity/saveActivityAuditConfig`, data, config);
}
//desc: "查看已邀约医生名单",
export function popularActivityGetPromotionUserPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/getPromotionUserPage`, data, config);
}
//desc: "查看已BAOMING名单",
export function activityDoctorFindPageActivityUserApplySubmit(data, config) {
  return post(`/c/pc/sp/activityDoctor/findPageActivityUserApplySubmit`, data, config);
}
//desc: "添加黑名单医生 校验手机号",
export function checkAddBlackUser(data, config) {
  return post(`/c/pc/sp/activityDoctor/checkAddBlackUser`, data, config);
}
//desc: "添加黑名单医生 导入excel",
export function importBlackUser(data, config) {
  return postFile(`/c/pc/sp/activityDoctor/importBlackUser`, data, config);
}
//desc: "添加黑名单医生 导出excel~失败名单",
export function exportFailBlackUserData(data, config) {
  return postExFile(`/c/pc/sp/activityDoctor/exportFailBlackUserData`, data, config);
}
//desc: "添加黑名单医生",
export function addBlackUser(data, config) {
  return post(`/c/pc/sp/activityDoctor/addBlackUser`, data, config);
}
//desc: "活动黑名单列表",
export function getBlackUserPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/getBlackUserPage`, data, config);
}
//desc: "活动黑名单列表",
export function removeBlackUser(data, config) {
  return post(`/c/pc/sp/activityDoctor/removeBlackUser`, data, config);
}
//desc: "校验活动黑名单医生",
export function popularActivityCheckPhone(data, config) {
  return post(`/c/pc/sp/activityDoctor/checkPhone`, data, config);
}
//desc: "添加医生 校验手机号",
export function popularActivityImportDoctor(data, config) {
  return postFile(`/c/pc/sp/activityDoctor/importDoctor`, data, config);
}
//desc: "下载错误文件",
export function popularActivityExportFailDoctorData(data, config) {
  return postExFile(`/c/pc/sp/activityDoctor/exportFailDoctorData`, data, config);
}
//desc: "下发邀请",
export function popularActivityAddPromotion(data, config) {
  return post(`/c/pc/sp/activityDoctor/commonAddPromotion`, data, config);
}
//获取任务审核明细列表
export function findActivityTaskUserRecordAuditPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonAuditRecordPage`, data, config);
}
/** 查询任务级标准文献信息 */
export function findLiteratureReviewInfo(data, config) {
  return post(`/c/pc/sp/activityContent/findLiteratureReviewInfo`, data, config);
}
/** 暂存任务级标准文献信息，不触发机审 */
export function saveLiteratureReviewInfo(data, config) {
  return post(`/c/pc/sp/activityContent/saveLiteratureReviewInfo`, data, config);
}
/** 保存任务级标准文献信息并继续文献述评机审 */
export function saveLiteratureReviewInfoAndResumeMachineAudit(data, config) {
  return post(`/c/pc/sp/activityContent/saveLiteratureReviewInfoAndResumeMachineAudit`, data, config);
}
/** 分页查询任务级文献信息变更记录 */
export function literatureReviewInfoChangeRecordPage(data, config) {
  return post(`/c/pc/sp/activityContent/literatureReviewInfoChangeRecordPage`, data, config);
}
//获取任务审核明细列表
export function activityTaskUserRecord_commonRevisionRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonRevisionRecordPage`, data, config);
}
//saas-通用统计追加审订待处理条数
export function countAppendRevisionIsPending(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/countAppendRevisionIsPending`, data, config);
}
//获取任务审核明细列表
export function activityTaskUserRecordUserRecordSubmittedCount(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/userRecordSubmittedCount`, data, config);
}
//获取任务审核明细列表
export function countActivityTaskUserRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/countActivityTaskUserRecord`, data, config);
}
//saas-审核提前校验接口
export function activityTaskUserRecordCheckAudit(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchCheckAudit`, data, config);
}
//获取任务采纳明细列表
export function activityTaskUserRecordCheckAdopt(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchCheckAdopt`, data, config);
}
//获取任务审核明细列表 V审核通过
export function activityTaskUserRecordApproveAudit(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/approveAudit`, data, config);
}
/// 查询审订记录列表;
export function findListContentSnapshotRevision(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findListContentSnapshotRevision`, data, config);
}
// 获取投稿正式机审结果;
export function getCommonAuditRecordDetail(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonAuditRecordDetail`, data, config);
}
// 点击模拟机审;
export function simulateMachine(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachine`, data, config);
}
// 机审原因查询;
export function simulateMachineReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachineReason`, data, config);
}
// 内部查重明细原因查询;
export function simulateMachineSearchContentRepeatRate(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachineSearchContentRepeatRate`, data, config);
}
// 内部查重明细原因查询;
export function simulateMachineQuestionnaireSubjectDuplicateDetail(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachineQuestionnaireSubjectDuplicateDetail`, data, config);
}
// 修改审订备注;
export function updateRevisionRemark(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateRevisionRemark`, data, config);
}
// 外部查重明细;
export function simulateMachineSearchOutsideContentRepeatRate(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachineSearchOutsideContentRepeatRate`, data, config);
}
// 标题重复查询;
export function simulateMachineSearchTitleRepeat(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateMachineSearchTitleRepeat`, data, config);
}
export function activityTaskUserRecordDownloadFile(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/downloadFile`, data, config);
}
export function activityTaskUserRecordRejectAudit(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/rejectAudit`, data, config);
}
export function activityTaskUserRecordUpdateRejectAuditReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateRejectAuditReason`, data, config);
}
export function activityTaskUserRecordUpdateRejectTaskRejection(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/taskRejection`, data, config);
}
//审核列表-内容主题设置
export function activityTaskUserRecordUpdateContentSubjectIds(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateContentSubjectIds`, data, config);
}
export function activityTaskUserRecordFindUserRepeatContributeRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findUserRepeatContributeRecordPage`, data, config);
}
//查询chatGPT 机审原因
export function activityTaskUserRecordMachineReasonChatGPT(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/machineReason`, data, config);
}
//文章查重具体记录
export function activityTaskUserRecordSearchContentRepeatRate(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/searchContentRepeatRate`, data, config);
}
//文章查重具体记录_TITLE
export function activityTaskUserRecordSearchTitleRepeat(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/searchTitleRepeat`, data, config);
}
//文章查重具体记录_外部
export function activityTaskUserRecordSearchOutsideContentRepeatRate(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/searchOutsideContentRepeatRate`, data, config);
}
//问卷主观题查重不通过原因查看
export function questionnaireSubjectDuplicateDetail(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/questionnaireSubjectDuplicateDetail`, data, config);
}
export function activityTaskUserRecordFindSnapshotBySnapshotId(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findSnapshotBySnapshotId`, data, config);
}
export function activityTaskUserRecordFindSnapshotBySnapshotIdWithoutToken(data, config) {
  return post(`/c/h5/sp/popularActivity/user/findSnapshotBySnapshotId`, data, config);
}
export function activityTaskUserRecordFindArticleReadNumByArticleIds(data, config) {
  return post(`/c/pc/sp/popularActivity/findArticleReadNumByArticleIds`, data, config);
}
// 采纳列表
export function activityTaskUserRecordAdoptRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonAdoptRecordPage`, data, config);
}
// 采纳列表
export function activityTaskUserRecordCountAdoptRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchCommonCountAdoptRecord`, data, config);
}
// 采纳列表_ 采纳通过;
export function activityTaskUserRecordApproveAdopt(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/approveAdopt`, data, config);
}
// 采纳列表_ 根据明细id统计采纳相关数据;
export function activityTaskUserRecordCountAuditDataByRecordId(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonCountAuditDataByRecordId`, data, config);
}
// 采纳列表_ 采纳不通过;
export function activityTaskUserRecordRejectAdopt(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/rejectAdopt`, data, config);
}
// 采纳列表_ 修改采纳不通过原因;
export function activityTaskUserRecordUpdateRejectAdoptReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateRejectAdoptReason`, data, config);
}
export function activityTaskUserRecordWaitConfirmRewardRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonWaitConfirmRewardRecordPage`, data, config);
}
//待激励列表统计数据
export function activityTaskUserRecordCountWaitConfirmRewardRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchCountWaitConfirmRewardRecord`, data, config);
}
export function activityTaskUserRecordEndActivityTask(data, config) {
  return post(`/c/pc/sp/popularActivity/batchEndActivityTask`, data, config);
}
// 批量操作, 将待审核批量审核不通过
export function waitingAudit2RejectAudited(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batch/waitingAudit2RejectAudited`, data, config);
}
// 批量操作, 将待审核批量采纳不通过;
export function waitingAdopt2RejectAdopted(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batch/waitingAdopt2RejectAdopted`, data, config);
}
// 激励发放列表;
export function activityTaskUserRecordRewardRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonRewardRecordPage`, data, config);
}
// 发放奖励-查询本次可扣减的客户公司账户列表（患管项目关联多家客户公司账户时供发奖弹窗选择）
export function listRewardDeductAccounts(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/listRewardDeductAccounts`, data, config);
}
export function activityTaskUserRecordReward(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchActivityReward`, data, config || {
    ignoreError: true
  });
}
export function activityTaskUserRecordRewardRecordExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonRewardRecordExport`, data, config);
}
//
export function activityTaskUserRecordCountTotalReward(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchCountTotalReward`, data, config);
}
//.批量确认激励
export function activityTaskUserRecordBatchConfirmReward(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/batchConfirmReward`, data, config);
}
// 新社区学术活动迁移-邀请医生-导入医生
export function academicActivityDoctorImportDoctor(data, config) {
  return postFile(`/c/pc/academicActivityDoctor/importDoctor`, data, config);
}
// 新社区学术活动迁移-邀请医生-下载错误文件
export function academicActivityDoctorExportFailDoctorData(data, config) {
  return postExFile(`/c/pc/academicActivityDoctor/exportFailDoctorData`, data, config);
}
// 新社区学术活动迁移-邀请医生-添加医生 校验手机号
export function academicActivityDoctorCheckPhone(data, config) {
  return post(`/c/pc/academicActivityDoctor/checkPhone`, data, config);
}
// 新社区学术活动迁移-邀请医生-获取医生信息
export function academicActivityDoctorPageInfo(data, config) {
  return post(`/c/pc/academicActivityDoctor/activityDoctorPageInfo`, data, config);
}
// 科普活动-批量确认激励导入
export function activityTaskUserRecordBatchConfirmRewardImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/batchActivityConfirmRewardImport`, data, config);
}
// 科普活动-批量发放激励导入
export function activityTaskUserRecordBatchActivityRewardImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/batchActivityRewardImport`, data, config);
}
// 科普活动-激励发放列表统计数据
export function activityTaskUserRecordCountRewardRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/countRewardRecord`, data, config);
}
// saas-设置发放备注
export function recordUpdateRewardRemark(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateRewardRemark`, data, config);
}
// saas-查看驳回原因
export function queryFinanceRejectReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/queryFinanceRejectReason`, data, config);
}
// 病例征集-获取病例详情
export function getH5QuestionnaireAnswerDetail(data, config) {
  return post(`/c/pc/community/questionnaire/getQuestionnaireAnswerDetail`, data, config);
}
// 获取职称相关;
export function getActivityProfessionTitleTree(data, config) {
  return post(`/c/pc/sp/activity/professionTitleTree`, data, config);
}
// 获取职称材料相关;
export function getActivityGetCertifications(data, config) {
  return post(`/c/pc/sp/activity/getCertifications`, data, config);
}
// 去审核-校验锁定
export function checkRedisAuditLimit(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/checkRedisAuditLimit`, data, config);
}
// 外部-任务审核明细列表 审核通过
export function approveAuditSuggestion(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/approveAuditSuggestion`, data, config);
}
// 批量审核通过查询 活动分类
export function checkBatchApproveAuditRuleInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/checkBatchApproveAuditRuleInfo`, data, config);
}
// 外部-任务审核明细列表 审核不通过
export function rejectAuditSuggestion(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/rejectAuditSuggestion`, data, config);
}
// 外部-任务审核明细列表 修改审核建议不通过原因
export function updateRejectAuditSuggestionReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateRejectAuditSuggestionReason`, data, config);
}
// 任务审核明细列表 更新活动任务审核建议
export function updateAuditSuggestionSwitch(data, config) {
  return post(`/c/pc/sp/activity/updateAuditSuggestionSwitch`, data, config);
}
// 任务审核明细列表 查询有操作建议的明细ids
export function findHaveSuggestionRecordId(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findHaveSuggestionRecordId`, data, config);
}
// 采纳列表-导出数据
export function activityTaskUserRecordCommonAdoptRecordExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonAdoptRecordExport`, data, config);
}
// 激励待确认列表-导出数据
export function activityTaskUserRecordCommonWaitConfirmRewardRecordExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonWaitConfirmRewardRecordExport`, data, config);
}
// 激励发放列表-导出数据
export function activityTaskUserRecordCommonRewardRecordV2Export(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonRewardRecordV2Export`, data, config);
}
// 激励待确认列表-导入数据检测
export function activityTaskUserRecordCheckBatchActivityConfirmRewardImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/checkBatchActivityConfirmRewardImport`, data, config);
}
// 激励发放列表-导入数据检测
export function activityTaskUserRecordCheckBatchActivityRewardImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/checkBatchActivityRewardImport`, data, config);
}
// 任务准备管理-课件审核列表/预约管理列表
export function activityTaskUserRecordCommonPreRecordAuditPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonPreRecordAuditPage`, data, config);
}
// 任务准备管理-取消任务
export function activityTaskUserRecordUneffectiveRecordPre(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/uneffectiveRecordPre`, data, config);
}
// 任务准备管理-课件审核列表-修改助手名称
export function updatePreRecordInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updatePreRecordInfo`, data, config);
}
// 任务准备管理-课件审核列表-批量审核通过
export function activityTaskUserRecordApproveAuditPreRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/approveAuditPreRecord`, data, config);
}
// 任务准备管理-课件审核列表-批量审核不通过
export function activityTaskUserRecordRejectAuditPreRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/rejectAuditPreRecord`, data, config);
}
// 任务准备管理-课件审核列表-修改审核不通过原因
export function activityTaskUserRecordUpdatePreRecordRejectAuditReason(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updatePreRecordRejectAuditReason`, data, config);
}
// 任务准备管理-课件审核列表-查询有操作建议的前置任务id
export function activityTaskUserRecordFindHaveSuggestionPreRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findHaveSuggestionPreRecord`, data, config);
}
// 任务准备管理-课件审核列表-批量确认退回
export function activityTaskUserRecordTaskRejectionPreRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/taskRejectionPreRecord`, data, config);
}
// 任务准备管理-课件审核列表-导出数据
export function activityTaskUserRecordCommonPreRecordAuditExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonPreRecordAuditExport`, data, config);
}
// 任务准备管理-课件审核列表-导出课件  压缩包
export function activityTaskUserRecordCommonPreRecordAuditSourceZipExport(data, config) {
  return postExFile(`/c/pc/sp/activityTaskUserRecord/commonPreRecordAuditSourceZipExport`, data, config);
}
// 任务准备管理-预约管理列表-预约取消
export function activityTaskUserRecordCommonCloseTaskRecord(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonCloseTaskRecord`, data, config);
}
// 任务准备管理-直播管理列表-查询直播任务列表
export function activityTaskUserRecordMedicLivePreRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/medicLivePreRecordPage`, data, config);
}
// 任务准备管理-直播管理列表-查看直播详情
export function activityTaskUserRecordGetLiveDetail(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/h5/live/getLiveDetail`, data, config);
}
// 任务准备管理-直播管理列表-获取直播间链接息
export function activityTaskUserRecordGetRoomUrl(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/getRoomUrl`, data, config);
}
// 任务准备管理-直播管理列表-获取直播间链接息
export function activityTaskUser_addAssistAccount(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/addAssistAccount`, data, config);
}
// 任务准备管理-直播管理列表-获取直播间链接息
export function activityTaskUser_removeAssistAccount(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/removeAssistAccount`, data, config);
}
// 任务准备管理-直播管理列表-修改直播间信息
export function activityTaskUserUpdateMedicLiveRoom(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/updateMedicLiveRoom`, data, config);
}
// 任务准备管理-直播管理列表-下发物料
export function activityTaskUserDistributeMaterials(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/distributeMaterials`, data, config);
}
// 任务准备管理-直播管理列表-直播间视频拉取上传
export function activityTaskUserPullUpload(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/pullUpload`, data, config);
}
// 任务准备管理-直播管理列表-查询直播回放列表
export function activityTaskUserListMedicLiveReplay(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/listMedicLiveReplay`, data, config);
}
// 任务准备管理-直播管理列表-直播(间)上下架
export function activityTaskUserListPutOnOff(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/putOnOff`, data, config);
}
// 任务准备管理-直播管理列表-导出直播回放列表
export function activityTaskUserListExportMedicLiveReplayList(data, config) {
  return postExFile(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/trtc/live/exportMedicLiveReplayList`, data, config);
}
// 任务准备管理-直播管理列表-导入物料
export function activityTaskUserListImportPreUserMaterial(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/importPreUserMaterial`, data, config);
}
// 任务准备管理-直播管理列表-导入物料素材
export function activityTaskUserListImportPrePosterUserMaterial(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/importPrePosterUserMaterial`, data, config);
}
// 任务准备管理-直播管理列表-下载错误文件
export function activityTaskUserListImportFailData(data, config) {
  return postExFile(`/c/pc/sp/commonActivity/importFailData`, data, config);
}
//desc: "获取视频素材辅导设置信息",
export function activityCommonConfigFindVideoMaterialGuidanceConfig(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/findVideoMaterialGuidanceConfig`, data, config);
}
//desc: "开启/关闭视频素材辅导设置",
export function activityCommonConfigSwitchVideoMaterGuidance(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/switchVideoMaterGuidance`, data, config);
}
//desc: "开启视频素材辅导分类",
export function activityCommonConfigOpenVideoMaterGuidanceSubject(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/openVideoMaterGuidanceSubject`, data, config);
}
//desc: "关闭视频素材辅导分类",
export function activityCommonConfigStopVideoMaterGuidanceSubject(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/stopVideoMaterGuidanceSubject`, data, config);
}
//desc: "",
export function activityTaskUserRecordFindSnapshotByRecordId(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findSnapshotByRecordId`, data, config);
}
export function activityTaskUserRecordFindSnapshotByRecordIdWithoutToken(data, config) {
  return post(`/c/h5/sp/popularActivity/user/findSnapshotByRecordId`, data, config);
}
//desc: "",
export function activityFindActivityUserByRecordId(data, config) {
  return post(`/c/h5/sp/activity/findActivityUserByRecordId`, data, config);
}
//desc: "采访任务创建列表",
export function activityDoctorInterviewUserPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/interviewUserPage`, data, config);
}
//desc: "新建采访任务",
export function activityDoctorCreateInterviewTask(data, config) {
  return post(`/c/pc/sp/activityDoctor/createInterviewTask`, data, config);
}
//desc: "采访管理统计数据",
export function activityTaskUserRecordCommonPreRecordCount(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonPreRecordCount`, data, config);
}
//desc: "下发采访 (批量)",
export function activityTaskUserRecordDistributeInterview(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/distributeInterview`, data, config);
}
//desc: "关闭采访",
export function activityTaskUserRecordCommonCloseTaskRecordPre(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonCloseTaskRecordPre`, data, config);
}
//desc: "检测导入采访",
export function checkBatchHealthInterviewQuestionImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/checkBatchHealthInterviewQuestionImport`, data, config);
}
//desc: "导入采访",
export function batchHealthInterviewQuestionImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/batchHealthInterviewQuestionImport`, data, config);
}
//desc: "采访内容编辑",
export function updateHealthInterviewInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/updateHealthInterviewInfo`, data, config);
}
/* 快问快答 start 2025-03-27 */
//desc: "题目列表",
export function activityTaskUserRecordAskInfoPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/askInfoPage`, data, config);
}
// findActivityCommonConfigNew 查询活动配置信息
//desc: "编辑活动配置信息",
export function activityCommonConfigSaveOrUpdateOneConfig(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/saveOrUpdateOneConfig`, data, config);
}
//desc: "查询项目分发上限配置",
export function findProjectConfig(data, config) {
  return post(`/c/pc/sp/activity/findProjectConfig`, data, config);
}
//desc: "保存项目分发上限配置",
export function activityCommonConfigSaveOrUpdateProjectConfig(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/saveOrUpdateProjectConfig`, data, config);
}
//desc: "题目导入检测",
export function activityTaskUserRecordCheckBatchAskImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/checkBatchAskImport`, data, config);
}
//desc: "题目导入",
export function activityTaskUserRecordBatchAskImport(data, config) {
  return postFile(`/c/pc/sp/activityTaskUserRecord/batchAskImport`, data, config);
}
//desc: "新建题目",
export function activityTaskUserRecordAddAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/addAskInfo`, data, config);
}
//desc: "编辑题目",
export function activityTaskUserRecordEditAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/editAskInfo`, data, config);
}
//desc: "查看题目",
export function activityTaskUserRecordAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/askInfo`, data, config);
}
//desc: "删除题目",
export function activityTaskUserRecordDeleteAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/deleteAskInfo`, data, config);
}
//desc: "暂停题目",
export function activityTaskUserRecordStopAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/stopAskInfo`, data, config);
}
//desc: "开启题目",
export function activityTaskUserRecordStartAskInfo(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/startAskInfo`, data, config);
}
//desc: "题目统计数据",
export function activityTaskUserRecordAskInfoCount(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/askInfoCount`, data, config);
}
//desc: "题目导出数据",
// export function activityTaskUserRecordAskInfoPageExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`/c/pc/sp/activityTaskUserRecord/askInfoPageExport`, data, config);
// }
/* 快问快答 end */
//desc: "SAAS-导入任务资源数据复审记录",
export function batchImportRecordSourceRevisonRecord(data, config) {
  return post(`/c/admin/sp/activity/batchImportRecordSourceRevisonRecord`, data, config);
}
//desc: "获取社区内素材分类列表",
export function activityCommonConfigFindVideoMaterialGuidanceSelect(data, config) {
  return post(`/c/pc/sp/activity/activityCommonConfig/findVideoMaterialGuidanceSelect`, data, config);
}
// 补充信息审核
export function commonApplySecondAuthWaitAuditPage(data, config) {
  return post(`/c/pc/sp/activityDoctor/commonApplySecondAuthWaitAuditPage`, data, config);
}
// 补充信息审核 通过  不通过
export function applySecondAuthAudit(data, config) {
  return post(`/c/pc/sp/activityDoctor/applySecondAuthAudit`, data, config);
}
// 审订页面查询素材列表
export function findMaterialDistributionByUserPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findMaterialDistributionByUserPage`, data, config);
}
// 审订锁定素材
export function lockMaterialForRevision(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/lockMaterialForRevision`, data, config);
}
// 查询素材详情
// 查询活动变更记录
export function findChangeLogPage(data, config) {
  return post(`/c/pc/sp/activity/findChangeLogPage`, data, config);
}
export function findMaterialDetail(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/findMaterialDetail`, data, config);
}
// SAAS-查询活动列表,
export function taskActivityFindByPage(data, config) {
  return post(`/c/pc/sp/popularActivity/taskActivityFindByPage`, data, config);
}
// 病例范式转换-增加方案,
export function addActivityCommonSetting(data, config) {
  return post(`/c/pc/sp/activity/addActivityCommonSetting`, data, config);
}
// 病例范式转换-修改方案,
export function updateActivityCommonSetting(data, config) {
  return post(`/c/pc/sp/activity/updateActivityCommonSetting`, data, config);
}
// 病例范式转换-方案详情,
export function findActivityCommonSettingDetail(data, config) {
  return post(`/c/pc/sp/activity/findActivityCommonSettingDetail`, data, config);
}
// 点评活动-复制病例文本规则
export function copyCaseTextShowRule(data, config) {
  return post(`/c/pc/sp/activity/copyCaseTextShowRule`, data, config);
}
// 创建活动-设置节假日
export function getActivityHoliday(data, config) {
  return post(`/c/pc/sp/activity/holiday`, data, config);
}
// 查重不通过详情-机审
export function activityTaskUserRecordCommonMachineSearchRepeat(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/commonMachineSearchRepeat`, data, config);
}
// 查重不通过详情-模拟机审
export function activityTaskUserRecordSimulateCommonMachineSearchRepeat(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/simulateCommonMachineSearchRepeat`, data, config);
}
/**
 * 医学会议（活动）
 */
// 分页查找需求审核全量信息列表
export function findPageDemandAuditFullInfo(data, config) {
  return post(`/c/pc/demand/findPageDemandAuditFullInfo`, data, config);
}
// 需求任务审核操作
export function demandTaskAuditOperate(data, config) {
  return post(`/c/pc/demand/demandTaskAuditOperate`, data, config);
}
// 修改需求任务备注
export function updateDemandTaskRemark(data, config) {
  return post(`/c/pc/demand/updateDemandTaskRemark`, data, config);
}
// 修改需求任务中的状态标签
export function updateDemandTaskDemandStatusTag(data, config) {
  return post(`/c/pc/demand/updateDemandTaskDemandStatusTag`, data, config);
}
// 修改需求任务活动关联关系
export function updateDemandTaskActivityRelation(data, config) {
  return post(`/c/pc/demand/updateDemandTaskActivityRelation`, data, config);
}
// 需求任务关闭
export function demandTaskClose(data, config) {
  return post(`/c/pc/demand/demandTaskClose`, data, config);
}
// 查询需求任务修改记录列表
export function findDemandTaskModifyRecordList(data, config) {
  return post(`/c/pc/demand/findDemandTaskModifyRecordList`, data, config);
}
// 需求任务修改审核操作
export function demandTaskModifyAuditOperate(data, config) {
  return post(`/c/pc/demand/demandTaskModifyAuditOperate`, data, config);
}
// 查询需求任务管理数据
export function findDemandTaskManageData(data, config) {
  return post(`/c/pc/demand/findDemandTaskManageData`, data, config);
}
// 需求任务管理数据创建
export function demandTaskManageDataCreate(data, config) {
  return post(`/c/pc/demand/demandTaskManageDataCreate`, data, config);
}
// 查询 需求修改待处理数量
export function findDemandTaskStatisticsData(data, config) {
  return post(`/c/pc/demand/findDemandTaskStatisticsData`, data, config);
}
// 多人会议 代提交任务
export function batchSubmitUserTask(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/proxy/batchSubmitUserTask`, data, config);
}
// 查询需求账号信息
export function findDemandAccountById(data, config) {
  return post(`/c/pc/demand/findDemandAccountById`, data, config);
}
export function findDemandSubmitRule(data, config) {
  return post(`/c/pc/demand/findDemandSubmitRule`, data, config);
}
export function demandSubmitRuleCreate(data, config) {
  return post(`/c/pc/demand/demandSubmitRuleCreate`, data, config);
}
// 分页查找需求账号列表
export function findPageDemandAccount(data, config) {
  return post(`/c/pc/demand/findPageDemandAccount`, data, config);
}
// 分页查找需求账号列表导出
export function findPageDemandAccountExport(data, config) {
  return postExFile(`/c/pc/demand/findPageDemandAccountExport`, data, config);
}
// 修改需求账号来源备注
export function updateDemandAccountSourceRemark(data, config) {
  return post(`/c/pc/demand/updateDemandAccountSourceRemark`, data, config);
}
// 修改需求账号状态
export function updateDemandAccountStatus(data, config) {
  return post(`/c/pc/demand/updateDemandAccountStatus`, data, config);
}
// 内容分发管理列表
export function activityTaskUserRecordReviewsDistributeRecordPage(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/reviewsDistributeRecordPage`, data, config);
}
// 点评内容管理-批量修改上限
export function reviewsDistributeBatchUpdate(data, config) {
  return post(`/c/pc/sp/activityTaskUserRecord/reviewsDistributeBatchUpdate`, data, config);
}
//desc: "查看社区自定义协议签署记录",
export function activitySignFindByPage(data, config) {
  return post(`/c/pc/sp/activitySign/findByPage`, data, config);
}
// 查询直播间事件变更历史
export function findEventHistory(data, config) {
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/h5/live/findEventHistory`, data, config);
  // return post(`https://business-rebuild-test.wenwo.com/medic-h5/v1/api/medic/h5/live/findEventHistory`, data, config);
}
// 预约修改前验证
export function liveTimeUpdateCheck(data, config) {
  // return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/h5/live/liveTimeUpdateCheck`, config || { ignoreError: true });
  return post(`${process.env.VUE_APP_B_HEALTH_LINK}/medic-h5/v1/api/medic/h5/live/liveTimeUpdateCheck`, data, config || {
    ignoreError: true
  });
}